import * as React from 'react';
import styled from 'styled-components';
import * as I from '../../icons';
import * as T from '../../serviceTheme';
import { useIORef } from '../../core/hooks';
import { useGetter, useEffect, useSetter } from './slots';

type Props = {
    onAction: (value: Record<string, any> | null, name: string) => void,
    className?: string,
}

export default ({ onAction, className }: Props) => {
    const { read: isVisible, write } = useIORef(false);

    const select =             useGetter('select');
    const service =            useGetter('service');
    const target =             useGetter('target');
    const dropdown =           useGetter('dropdown');

    const [, runActive] =      useEffect('actionActive');
    const [, runInactive] = useEffect('actionInactive');
    const [changeTarget] =     useEffect('changeTarget');
    const [changeValue] =      useEffect('changeValue');

    const batch = () => {
        onAction(target.getValue(), service.name);
        select.off();
    }
    
    const targetIsEmpty = target.isEmpty();
    const dropdownIsOpen = dropdown.isOpen();

    useSetter('action', {
        batch,
        isVisible,
    });

    React.useEffect(() => {
        const x = !targetIsEmpty && dropdownIsOpen;
        const w = write(x);

        if(x){
            runActive(w)();
        }
        else {
            runInactive(w)();
        }

    }, [changeTarget, changeValue]);

    return (
        <Wrapper style={render(isVisible())}>
            <Button 
                onMouseDown={batch}
                className={className}>
                <I.Done />
            </Button>
        </Wrapper>
    );
}

const render = (b: boolean): React.CSSProperties => {
    return b 
        ? { opacity: 1, pointerEvents: 'auto' } 
        : { opacity: 0, pointerEvents: 'none' }
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 7px;
    margin-right: -3px;
    width: 16px;
    position: relative;
`;

const Button = styled.button`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    margin-right: 5px;

    > svg {
        fill: ${T.safeGetPrimary};
        position: absolute;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 16px;
        transform: translate(-50%, -50%);
    }
`;
